/** Helpers financiers modal détail commande produit (partagés commerçant / plateforme). */

export const isCommandePaiementEnLigne = (cmd) =>
  cmd?.modePaiement === 'enligne' ||
  ['paypal', 'applepay', 'googlepay'].includes(String(cmd?.modePaiement || '').toLowerCase());

export function getCommandeSoldeRemboursable(cmd) {
  const paiements = cmd?.paiements || [];
  const encaisse = paiements
    .filter((p) => p.statutPaiement === 'VALIDE' && Number(p.montant) > 0)
    .reduce((s, p) => s + Number(p.montant), 0);
  const rembourse = Math.abs(
    paiements
      .filter((p) => p.statutPaiement === 'REMBOURSE' && Number(p.montant) < 0)
      .reduce((s, p) => s + Number(p.montant), 0),
  );
  return Math.round((encaisse - rembourse) * 100) / 100;
}

export function hasStripePaymentIntent(cmd) {
  return (cmd?.paiements || []).some(
    (p) =>
      p.statutPaiement === 'VALIDE' &&
      Number(p.montant) > 0 &&
      p.providerTransactionId &&
      String(p.providerTransactionId).startsWith('pi_'),
  );
}

function isStripeEncaissementPaiement(p) {
  if (!p || Number(p.montant) <= 0 || p.statutPaiement !== 'VALIDE') return false;
  if (p.typePaiement === 'REMBOURSEMENT') return false;
  if (String(p.paymentProvider || '').toUpperCase() === 'STRIPE') return true;
  const pid = String(p.providerTransactionId || '');
  return pid.startsWith('pi_') || pid.startsWith('ch_');
}

function isCaisseLedgerEncaissementPaiement(p) {
  if (!p || Number(p.montant) <= 0 || p.statutPaiement !== 'VALIDE') return false;
  if (p.typePaiement === 'REMBOURSEMENT') return false;
  return !isStripeEncaissementPaiement(p);
}

export function hasCaisseLedgerEncaissement(cmd) {
  return (cmd?.paiements || []).some(isCaisseLedgerEncaissementPaiement);
}

export function hasMixedStripeAndCaisseEncaissement(cmd) {
  const paiements = cmd?.paiements || [];
  const hasStripe = paiements.some(isStripeEncaissementPaiement);
  const hasCaisse = paiements.some(isCaisseLedgerEncaissementPaiement);
  return hasStripe && hasCaisse;
}

/** ROUTE-2 — commande Web encaissée en caisse, remboursable via POST /caisse/commande/:id/rembourser-surplace */
export function canRefundWebEncaisseCaisse(cmd) {
  if (!cmd || cmd.canalVente === 'POS') return false;
  const paiements = cmd.paiements || [];
  const hasStripe = paiements.some(isStripeEncaissementPaiement);
  const hasCaisse = paiements.some(isCaisseLedgerEncaissementPaiement);
  if (hasStripe && hasCaisse) return false;
  if (hasStripe || isCommandePaiementEnLigne(cmd)) return false;
  if (!hasCaisse) return false;
  const solde = getCommandeSoldeRemboursable(cmd);
  const paidOk =
    cmd.statutPaiement === 'VALIDE' ||
    cmd.statutPaiement === 'REMBOURSE' ||
    (cmd.statutPaiement === 'EN_ATTENTE' && solde > 0.01);
  return paidOk && solde > 0.01;
}

export function parseSavReference(reference) {
  if (!reference) return null;
  if (typeof reference === 'object') return reference;
  try {
    return JSON.parse(reference);
  } catch {
    return null;
  }
}
